function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8996 15.933C19.7864 15.4987 21.9996 13.0078 21.9996 10C21.9996 6.68629 19.3133 4 15.9996 4C12.6859 4 9.99961 6.68629 9.99961 10C9.99961 13.0078 12.2129 15.4987 15.0996 15.933V19.1H12.8996C12.4026 19.1 11.9996 19.5029 11.9996 20C11.9996 20.4971 12.4026 20.9 12.8996 20.9H19.0996C19.5967 20.9 19.9996 20.4971 19.9996 20C19.9996 19.5029 19.5967 19.1 19.0996 19.1H16.8996V15.933ZM20.1996 10C20.1996 12.3196 18.3192 14.2 15.9996 14.2C13.68 14.2 11.7996 12.3196 11.7996 10C11.7996 7.6804 13.68 5.8 15.9996 5.8C18.3192 5.8 20.1996 7.6804 20.1996 10Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.52585 4.26988C7.76054 4.43904 7.89961 4.7107 7.89961 5V10.1H8.89961V17.5C8.89961 19.3778 7.37738 20.9 5.49961 20.9C3.62184 20.9 2.09961 19.3778 2.09961 17.5V10.1H3.09961V6C3.09961 5.61261 3.3475 5.26869 3.715 5.14619L6.715 4.14619C6.98946 4.0547 7.29116 4.10073 7.52585 4.26988ZM6.09961 6.24868V10.1H4.89961V6.64868L6.09961 6.24868ZM3.89961 11.9H7.09961V17.5C7.09961 18.3837 6.38326 19.1 5.49961 19.1C4.61595 19.1 3.89961 18.3837 3.89961 17.5V11.9Z",
  fill: "currentColor"
});

var SvgBeautyOutline24 = function SvgBeautyOutline24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeautyOutline24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beauty-outline-24.782788b7.svg";
export { ForwardRef as ReactComponent };